<div class="dashboard__content mt-4 pb-5" [class.d-none]="!isLoaded">
<div class="row mb-4 wh-breadcrumb g-0 text-uppercase">

    <div class="col-auto">
        <span class="small text-muted">Winning Hands Admin</span>
    </div>
    <div class="col-auto">
        <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
        <a [routerLink]="[ '/', 'admin', 'events' ]" class="small text-muted text-decoration-none"> Events</a>
    </div>
    <div class="col-auto">
        <span class="small text-muted">&nbsp;<mat-icon>chevron_right</mat-icon>&nbsp;</span>
    </div>
    <div class="col-auto">
        <a [routerLink]="[ '/', 'admin', 'events', 'all-events' ]" class="small text-primary text-decoration-none"> All
            events</a>
    </div>
</div>
<div class="row mb-4">
    <div class="col">
        <h1 class="mb-0">ALL EVENTS</h1>
    </div>
    <div class="col-auto">
         <button class="d-block d-lg-inline-block w-100" (click)="addEvent()" mat-flat-button color="primary">ADD EVENT</button>
    </div>

</div>



<div class="row">
    <div class="col-8">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Search events</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Eg. Coventry 2025">
        </mat-form-field>
    </div>
    <div class="col-4">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Event status</mat-label>
            <mat-select [(value)]="eventStatus" (selectionChange)="filterTable($event.value);">
                <mat-option [value]="0">All</mat-option>
                @for (status of eventStatuses; track status.eventStatusID){
                <mat-option [value]="status.eventStatusID">{{status.statusName}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</div>


<div class="row">
    <div class="col-12" style="width: 100%; overflow-x: auto;">
        <table matSort class="admin-table" mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="eventName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>EVENT NAME</th>
                <td mat-cell *matCellDef="let element">{{element.eventName}} </td>
            </ng-container>
            <ng-container matColumnDef="venueName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>VENUE</th>
                <td mat-cell *matCellDef="let element"> {{element.venueName}} </td>
            </ng-container>

            <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>CITY</th>
                <td mat-cell *matCellDef="let element"> {{element.city}} </td>
            </ng-container>

            <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>COUNTRY</th>
                <td mat-cell *matCellDef="let element"> {{element.country}} </td>
            </ng-container>
            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>START DATE</th>
                <td mat-cell *matCellDef="let element"> {{element.startDate|date:'dd MMM YYYY'}} </td>
            </ng-container>
            <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>END DATE</th>
                <td mat-cell *matCellDef="let element"> {{element.endDate|date:'dd MMM YYYY'}} </td>
            </ng-container>

            <ng-container matColumnDef="eventStatusID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
                <td mat-cell *matCellDef="let element"> {{getEventStatus(element.eventStatusID)}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>ACTIONS</th>
                <td mat-cell *matCellDef="let element">

                    <button (click)="editEvent(element.eventID)" mat-icon-button aria-label="Edit event">
                      <mat-icon>settings</mat-icon>
                    </button>

                    <button (click)="deleteEvent(element.eventID, element.eventName)" mat-icon-button aria-label="Delete event">
                      <mat-icon>delete</mat-icon>
                    </button>


                    <button (click)="goToEventDashboard(element.eventID)" mat-icon-button aria-label="View event dashboard">
                      <mat-icon>dashboard</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
</div>